<template>
   <div>
    <van-popup class="send-main" v-model="messageShow">
        <div class="send-email-container">
            <div class="top-email-icon">
                <img :src="cdnUrl + 'FvpdBdFGEGedIzbbhLWMgc2LyVJW'" class="mess-icon" alt="">
                <p>{{ title }}</p>
            </div>
            <button class="send-container" @click="handleOk">确定</button>
        </div>
    </van-popup>
  </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '下载成功'
        }
    },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            messageShow: false, // 显示
            type: ''
        }
    },
    methods: {
        showMessge(data) {
            this.messageShow = true
            this.type = data
        },
        handleOk() {
            this.messageShow = false
            this.$router.push({
                name: 'polyDetail',
                query: {
                    id: this.$route.query.id,
                    uid: this.$route.query.uid
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .send-main {
        border-radius: 4px;
        .send-email-container{
            width: rem(297);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #fff;
            margin: 0 auto;
        }
        .top-email-icon {
            .mess-icon {
                margin: rem(38) 0 rem(22) 0;
            }
            p {
                margin-bottom: rem(96);
                text-align: center;
            }
        }
        .send-container{
            display: block;
            width: rem(219);
            height: rem(49);
            font-size: 13px;
            margin-bottom: rem(38);
            outline: none;
            border: none;
            background: #6CC5DB;
            color: #FEFEFE;
            border-radius:4px;
        }
    }
</style>